// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"UserItem_gridContainer__3kiZO","gridItem":"UserItem_gridItem__3rgC-","name":"UserItem_name__2n2Df","button":"UserItem_button__ttpr6"};